import { render, staticRenderFns } from "./ModalVue.vue?vue&type=template&id=18c19921&scoped=true&"
import script from "./ModalVue.vue?vue&type=script&lang=js&"
export * from "./ModalVue.vue?vue&type=script&lang=js&"
import style0 from "./ModalVue.vue?vue&type=style&index=0&id=18c19921&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c19921",
  null
  
)

export default component.exports